import { render, staticRenderFns } from "./Ferias.vue?vue&type=template&id=d9dfa408&scoped=true"
import script from "./Ferias.vue?vue&type=script&lang=js"
export * from "./Ferias.vue?vue&type=script&lang=js"
import style0 from "./Ferias.vue?vue&type=style&index=0&id=d9dfa408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dfa408",
  null
  
)

export default component.exports